module.exports = __webpack_public_path__ + "static/img/30001 (2).fe7025a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30001 (2).webp
// module id = 6ozl
// module chunks = 14